import React, { useState } from "react";
import { IconDownload, IconEye, IconSearch, IconX } from "@tabler/icons-react";
import ColumnsFilter from "../../components/common/ColumnsFilter";
import DropdownFilter from "../../components/common/DropdownFilter";
import EntriesSelector from "../../components/common/EntriesSelector";
import ListView from "../../components/common/ListView";
import ViewModal from "./_components/ViewModal";
import PermissionGuard from "../../components/PermissionGuard";

const invoiceData = [
  {
    id: 1,
    invoiceId: "INV12345",
    date: "4 Aug 2025",
    description: "Monthly Service Fee",
    amount: "100 SAR",
    dueDate: "10-Jun-25",
    status: "Unpaid",
    active: false,
  },
  {
    id: 2,
    invoiceId: "INV12345",
    date: "4 Aug 2025",
    description: "Monthly Service Fee",
    amount: "100 SAR",
    dueDate: "10-Jun-25",
    status: "Paid",
    download: "Downloading...",
    active: true,
  },
  {
    id: 3,
    invoiceId: "INV12345",
    date: "4 Aug 2025",
    description: "Monthly Service Fee",
    amount: "100 SAR",
    dueDate: "10-Jun-25",
    status: "Unpaid",
    active: false,
  },
  {
    id: 4,
    invoiceId: "INV12345",
    date: "4 Aug 2025",
    description: "Monthly Service Fee",
    amount: "100 SAR",
    dueDate: "10-Jun-25",
    status: "Paid",
    active: true,
  },
  {
    id: 5,
    invoiceId: "INV12345",
    date: "4 Aug 2025",
    description: "Monthly Service Fee",
    amount: "100 SAR",
    dueDate: "10-Jun-25",
    status: "Unpaid",
    active: true,
  },
];

const InvoiceManagement: React.FC = () => {
  const [selectedInvoice, setSelectedInvoice] = useState<any>(null);
  const openInvoice = (invoice: any) => setSelectedInvoice(invoice);
  const closeInvoice = () => setSelectedInvoice(null);

  const [searchFor, setSearchFor] = useState<string>("");
  const [showSearch, setShowSearch] = useState<boolean>(false);
  const [limit, setLimit] = useState<number>(10);

  const [columnsData, setColumnsData] = useState([
    { text: "S/N", value: "sn", isShow: true },
    { text: "Invoice Id", value: "invoiceId", isShow: true },
    { text: "Date", value: "date", isShow: true },
    { text: "Description", value: "description", isShow: true },
    { text: "Amount", value: "amount", isShow: true },
    { text: "Due Date", value: "dueDate", isShow: true },
    { text: "Status", value: "status", isShow: true },
    { text: "Actions", value: "actions", isShow: true },
  ]);

  const setHeadings = (value: string | undefined, checked: boolean) => {
    setColumnsData((prev) =>
      prev.map((col) =>
        col.value === value ? { ...col, isShow: checked } : col
      )
    );
  };

  const filteredInvoiceData = invoiceData.filter((item) => {
    if (!searchFor) return true;
    const s = searchFor.toLowerCase();
    return (
      item.invoiceId.toLowerCase().includes(s) ||
      item.description.toLowerCase().includes(s) ||
      item.amount.toLowerCase().includes(s) ||
      item.dueDate.toLowerCase().includes(s) ||
      item.status.toLowerCase().includes(s) ||
      item.date.toLowerCase().includes(s)
    );
  });

  const columns = columnsData
    .filter((c) => c.isShow)
    .map((col) => {
      switch (col.value) {
        case "sn":
          return {
            label: "S/N",
            render: (_: any, i: number) => i + 1,
          };
        case "invoiceId":
          return { label: "Invoice Id", render: (c: any) => c.invoiceId };
        case "date":
          return { label: "Date", render: (c: any) => c.date };
        case "description":
          return { label: "Description", render: (c: any) => c.description };
        case "amount":
          return { label: "Amount", render: (c: any) => c.amount };
        case "dueDate":
          return { label: "Due Date", render: (c: any) => c.dueDate };
        case "status":
          return {
            label: "Status",
            render: (c: any) => (
              <div className="flex justify-start">
                <button
                  className="rounded-full w-24 px-4 py-1 text-center border border-slate-200 bg-[#F7F6F2] text-slate-700 text-xs font-medium"
                >
                  {c.status}
                </button>
              </div>
            ),
          };
        case "actions":
          return {
            label: "Actions",
            render: (c: any) => (
              <div className="flex items-center justify-start">
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    openInvoice(c);
                  }}
                  className="px-4 text-center py-2 border rounded-full bg-[#F7F6F2]"
                >
                  Download
                </button>
              </div>
            ),
          };
        default:
          return { label: "", render: () => null };
      }
    });

  const isAnySidePanelOpen = !!selectedInvoice;

  return (
    <PermissionGuard module="invoices" action="read">
      <div className="p-4">
        <div className="relative grid grid-cols-12 gap-6 p-2 bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl transition-all duration-300 w-full rounded-r-3xl rounded-bl-3xl">
          <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />

          {/* Left Column: Invoice Table Card */}
          <div
            className={`${
              isAnySidePanelOpen
                ? "col-span-12 xl:col-span-7"
                : "col-span-12"
            } flex flex-col gap-3 z-10`}
          >
            <div className="bg-white rounded-3xl border border-slate-100 shadow-sm overflow-visible mb-6" style={{ minHeight: "150px" }}>
              {/* Header Row (Filters + Actions Unified) */}
              <div className="px-6 py-1.5 flex flex-col lg:flex-row lg:items-center justify-between gap-4">
                {/* Left side: Brand badge */}
                <div className="flex flex-wrap items-center gap-3">
                   
                </div>

                {/* Right side: Export + Search + Advanced Filters */}
                <div className="flex items-center flex-wrap gap-2.5">
                  {/* Sliding Search */}
                  <div className="relative flex items-center">
                    <div
                      onClick={() => {
                        if (!showSearch) {
                          setShowSearch(true);
                        }
                      }}
                      className={`flex items-center transition-all duration-300 ease-in-out border border-slate-200 rounded-lg bg-white shadow-sm h-8 ${
                        showSearch ? "w-64 px-2 cursor-default" : "w-8 justify-center cursor-pointer hover:bg-slate-50 hover:shadow-md hover:-translate-y-0.5 active:translate-y-0 active:scale-95 transition-all duration-150"
                      }`}
                    >
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowSearch(!showSearch);
                        }}
                        className="flex items-center justify-center text-slate-700 focus:outline-none flex-shrink-0"
                        title="Search"
                      >
                        <IconSearch size={17} stroke={2.5} />
                      </button>
                      {showSearch && (
                        <>
                          <input
                            type="text"
                            value={searchFor}
                            onChange={(e) => {
                              setSearchFor(e.target.value);
                            }}
                            placeholder="Search..."
                            autoFocus
                            className="flex-1 ml-2 bg-transparent text-xs text-slate-800 placeholder-slate-400 outline-none border-none"
                          />
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              setSearchFor("");
                              setShowSearch(false);
                            }}
                            className="flex items-center justify-center p-0.5 ml-1 text-slate-400 hover:text-slate-600 focus:outline-none flex-shrink-0"
                            title="Clear & Close"
                          >
                            <IconX size={14} stroke={2.5} />
                          </button>
                        </>
                      )}
                    </div>
                  </div>

                  {/* Export */}
                  <button
                    className="flex items-center justify-center bg-white hover:bg-slate-50 border border-slate-200 text-slate-700 rounded-lg transition-all duration-150 shadow-sm hover:shadow-md hover:-translate-y-0.5 active:translate-y-0 active:scale-95 cursor-pointer h-8 w-8"
                    title="Export to Excel"
                  >
                    <IconDownload size={17} stroke={2.5} />
                  </button>

                  {/* Entries limit selector */}
                  <EntriesSelector
                    value={limit}
                    options={[10, 20, 30, 50, 100]}
                    onChange={(val) => {
                      setLimit(val);
                    }}
                  />

                  {/* Columns Filter */}
                  <ColumnsFilter
                    triggerClassName="border border-slate-200 bg-white rounded-lg p-1.5 cursor-pointer text-[#212121] hover:bg-slate-50 hover:shadow-md hover:-translate-y-0.5 active:translate-y-0 active:scale-95 transition-all duration-150 h-8 w-8 flex items-center justify-center shadow-sm select-none"
                    columnsData={columnsData}
                    setHeadings={setHeadings}
                  />

                  {/* Dropdown Filter */}
                  <DropdownFilter
                    filterheadings={[]}
                    triggerClassName="border border-slate-200 bg-white rounded-lg p-1.5 cursor-pointer text-[#212121] hover:bg-slate-50 hover:shadow-md hover:-translate-y-0.5 active:translate-y-0 active:scale-95 transition-all duration-150 h-8 w-8 flex items-center justify-center shadow-sm select-none"
                    iconSize={17}
                  />
                </div>
              </div>

              <div className="border-t border-slate-100 rounded-b-3xl overflow-hidden">
                <ListView
                  data={filteredInvoiceData.slice(0, limit)}
                  onRowClick={(client) => openInvoice(client)}
                  columns={columns}
                  mainDivClassName="bg-white rounded-3xl"
                  mailDivClassName="p-0 rounded-3xl"
                />
              </div>
            </div>
          </div>

          {/* Right Column: Invoice Sidebar Panel */}
          {isAnySidePanelOpen && (
            <>
              <div
                className="fixed inset-0 bg-black/40 z-30 xl:hidden"
                onClick={closeInvoice}
              />
              <div className="col-span-12 xl:col-span-5 relative mt-2 xl:static fixed inset-y-0 right-0 z-30 w-full sm:w-[450px] xl:w-auto p-4 pt-[76px] sm:pt-[96px] xl:p-0 shadow-2xl xl:shadow-none bg-white xl:bg-transparent overflow-y-auto xl:overflow-visible flex flex-col justify-start min-h-[500px]">
                <ViewModal invoice={selectedInvoice} onClose={closeInvoice} />
              </div>
            </>
          )}
        </div>
      </div>
    </PermissionGuard>
  );
};

export default InvoiceManagement;
